import React from "react";
import CreditNotes from "./CreditNoteLists/CreditNotes";

const ApprovedCreditNotes = () => {
    return <CreditNotes status="approved" title="approved" link="approved-credit-notes"/>;
};

export default ApprovedCreditNotes;
